/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { get, map, toString, isEmpty } from "lodash";
import { IconButton, Pagination, Stack, Chip, Menu, MenuItem, Link as LinkMui, } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PhoneIcon from '@mui/icons-material/Phone';
import { Link } from "react-router-dom";

import Layout from "../../../components/layout/Layout"
import Table from "../../../components/form/TableFilter";
import Toolbar from "./Toolbar";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import { PageSize, countPage } from "../../../config/const";
import Question from "../../../components/form/Question";
import { useCanView } from "../../../config/hook/UserPermissions";

import { getDeliveryPoint } from "../../../store/masters/thunk/deliveryPoint/getAll";
import { deleteDeliveryPoint } from "../../../store/masters/thunk/deliveryPoint/delete";

const DeliveryPoints = () => {
  const [__] = useTranslation("delivery");
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({})
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })
  const [openQuestion, setOpenQuestion] = useState(null);
  const canView = useCanView();

  const deliveryPoints = useSelector(state => state.masters.deliveryPoints);
  const put = useSelector(state => state.masters.deliveryPoints.put);
  const delet = useSelector(state => state.masters.deliveryPoints.delete);

  const getData = ({ page, filters = filter }) => {
    const { code, phone, ...rest } = filters;
    const params = {
      page,
      ...rest,
      ...(code !== undefined && { DeliveryCode: code }),
      ...(phone !== undefined && { ContactPhone: phone }),
    };
    dispatch(getDeliveryPoint({ ...params, Export: false }))
  }

  const reload = () => {
    handleCloseMenu()
    closeAlert()
    getData({ page: 1 })
  }

  useEffect(() => {
    setAnchorEl(false)
    getData({ page: 1})
  }, []);

  const onFilterChange = (key, value) => {
    const updatedFilters = { ...filter, [key]: value };
    setFilter(updatedFilters);
    getData({ page: 1, filters: updatedFilters });
  };

  const handleOpenMenu = (row) => (event) => {
    setSelected(row)
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setSelected({})
    setAnchorEl(null);
  };

  const onDelete = () => {
    dispatch(deleteDeliveryPoint(get(selected, "idDeliveryPoint")))
    setSelected({})
  }
  const handleDelete = (row) => () => {
    setAnchorEl(null)
    setOpenQuestion(true)
    setSelected(row)
  }

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    setOpenQuestion(false)
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }
    handleCloseMenu()
  }

  useEffect(() => {
    if (get(delet, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
    if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
    if (get(put, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
  }, [put, delet])

  const headTable = [
    {
      key: "StatusDescription",
      label: __(`table.cols.isActive`),
      align: "center"
    },
    {
      key: "code",
      label: __(`table.cols.deliveryCode`),
      align: "center"
    },
    {
      key: "deliveryName",
      label: __(`table.cols.deliveryName`),
      align: "center"
    },
    {
      key: "contactName",
      label: __(`table.cols.contactName`),
      align: "center"
    },
    {
      key: "phone",
      label: __(`table.cols.contactPhone`),
      align: "center"
    },
    {
      key: "contactEmail",
      label: __(`table.cols.contactEmail`),
      align: "center"
    },
    {
      key: "municipality",
      label: __(`table.cols.city`),
      align: "center"
    },
    {
      key: "options",
      label: __(`table.cols.options`),
      align: "center",
      sx: { position: "sticky", right: 0, pr: 1, width: 40, minWidth: 40, background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)" }
    },
  ]

  const dataTable = map(get(deliveryPoints, "data.data", []), (row, i) => ({
    ...row,
    code: <LinkMui component={Link} to={toString(get(row, "idDeliveryPoint"))} >{get(row, "deliveryCode")}</LinkMui>,
    phone: get(row, "contactPhone", "") && <Stack direction="row" alignItems="center" spacing={1} ><PhoneIcon fontSize="small" /><div>{get(row, "contactPhone")}</div></Stack>,
    StatusDescription: <Chip label={get(row, "statusDescription", "")} color={get(row, "statusDescription") === "ACTIVO" ? "success" : "error"} />,
    options: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}><MoreVertIcon fontSize="inherit" /></IconButton>
  }))

  const onChangePagination = (e, page) => getData({ page, filter })

  return (
    <Layout
      propsToolbar={{
        title: __(`head.name`),
        code: null,
        btnLabel: null
      }}
    >
      <Toolbar setFilter={setFilter} __={__} getData={getData} reload={reload} isLoading={get(deliveryPoints, "isLoading", false)} />
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        propsTable={{ showFilterRow: true }}
        filters={filter}
        onFilterChange={onFilterChange}
        loading={get(deliveryPoints, "isLoading", false)}
      />
      <Stack sx={{ mt: 2 }} alignItems="flex-end">
        <Pagination
          count={countPage(get(deliveryPoints, "data.totalRecord", 1))}
          page={get(deliveryPoints, "data.currentPage", 1)}
          onChange={onChangePagination}
          color="secondary"
          sx={{ "& li > button": { borderRadius: 1 } }}
          disabled={get(deliveryPoints, "isLoading", false)}
        />
      </Stack>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        <Link to={toString(get(selected, "idDeliveryPoint"))}><MenuItem >{__(`table.menu.edit`)}</MenuItem></Link>
        <MenuItem onClick={ () => {
            if (canView("MAESTROS/PUNTOS DE ENTREGA", "delete")) {
              handleDelete(selected)()
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para eliminar puntos de entrega.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
        }}>{__(`table.menu.delete`)}</MenuItem>
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
      <Question
        title={__("alert.delete.title")}
        detail={__("alert.delete.detail")}
        onSuccess={onDelete}
        onCancel={() => setOpenQuestion(false)}
        open={openQuestion}
        loading={get(delet, "isLoading")}
      />
    </Layout>
  )
}

export default DeliveryPoints;


